import { render, staticRenderFns } from "./testInfo.vue?vue&type=template&id=1183d918&scoped=true"
import script from "./testInfo.vue?vue&type=script&lang=js"
export * from "./testInfo.vue?vue&type=script&lang=js"
import style0 from "./testInfo.vue?vue&type=style&index=0&id=1183d918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1183d918",
  null
  
)

export default component.exports